module.exports = __webpack_public_path__ + "static/media/icon-bulb.ce960733.svg";